import { h, FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import * as styles from '~src/styles/domains/common/components/processing.module.scss';
import Loading from './Loading';

const ProcessingView: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.processing} role='alert' id='processing'>
      <Loading />
      <h1 className={styles['processing-label']}>{t(`common:processing`)}</h1>
    </div>
  );
};

export default ProcessingView;
